// Privacy-conscious, dependency-free funnel analytics.
// Events are pushed to window.dataLayer (GA4 / Google Tag Manager compatible) so the
// business can connect a real analytics tool later WITHOUT any code change here.
// No PII is ever sent — only non-identifying funnel facts (service type, source,
// counts, estimate ranges). No data is fabricated; events fire only on real actions.

const isBrowser = typeof window !== "undefined";

// Fields we explicitly allow through — everything else is dropped to avoid PII leakage.
const ALLOWED_KEYS = new Set([
  "source", "entry", "service", "detail_level", "condition", "urgency", "scenario",
  "sqm", "bathrooms", "rooms", "addons_count", "photos", "estimate_low", "estimate_high",
  "status", "step", "package", "has_media",
]);

function sanitize(props = {}) {
  const out = {};
  for (const [k, v] of Object.entries(props)) {
    if (!ALLOWED_KEYS.has(k)) continue;
    if (v === undefined || v === null || v === "") continue;
    // Coerce to primitives only; never forward objects/arrays that could carry PII.
    if (typeof v === "object") continue;
    out[k] = v;
  }
  return out;
}

export function track(event, props = {}) {
  if (!isBrowser || !event) return;
  const payload = { event: `ascendia_${event}`, ...sanitize(props), ts: Date.now() };
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (process.env.NODE_ENV !== "production") {
      // Dev visibility only; production stays silent.
      console.debug("[analytics]", payload.event, payload);
    }
  } catch (e) {
    // Analytics must never break the app; surface only in dev.
    if (process.env.NODE_ENV !== "production") console.debug("[analytics] push failed", e);
  }
}

// Named funnel events (single source of truth for event names).
export const Events = {
  planStarted: (p) => track("property_plan_started", p),
  planCompleted: (p) => track("property_plan_completed", p),
  estimateViewed: (p) => track("estimate_viewed", p),
  askOpened: (p) => track("ask_ascendia_opened", p),
  quoteStarted: (p) => track("quote_started", p),
  quoteSubmitted: (p) => track("quote_submitted", p),
  rescueStarted: (p) => track("rescue_started", p),
  quoteAccepted: (p) => track("quote_accepted", p),
  bookingRequested: (p) => track("booking_requested", p),
};

export default track;
